<template>
  <div>
    <div class="form-container">
      <el-form label-width="120px">
        <el-form-item label="消费积分比例">
          <el-input v-model="pointsPerYuan">
            <template #append>
              <span>积分/元</span>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "System",
  data() {
    return {
      pointsPerYuan: 1
    }
  }
}
</script>

<style lang="scss" scoped>
.form-container {
  width: 600px;
  padding: 12px;
  background-color: #ffffff;
  border: 1px solid #dddddd;
}
</style>
